import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiZeistSchipholPage() {
  return (
    <CityAirportTemplate
      city="Zeist"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={62.50}
      distance="52 km"
      duration="40-45 minuten"
    />
  );
}
